import { getCookie, COOKIE_NAMES } from '@/utils/cookies'

/**
 * Base API configuration
 */

export const API_BASE = import.meta.env.VITE_API_URL ?? 'http://localhost:8787'

/**
 * Default fetch options for API requests
 */
export const defaultFetchOptions: RequestInit = {
  credentials: 'include', // Include cookies in all requests
  headers: {
    'Content-Type': 'application/json',
  },
}

// Module-level token cache — set on login, cleared on logout
let _authToken: string | null = null

export function setApiToken(token: string | null) {
  _authToken = token
}

/**
 * Get the current auth token — memory first, then cookie fallback
 */
function getToken(): string | null {
  return _authToken ?? getCookie(COOKIE_NAMES.AUTH_TOKEN)
}

/**
 * Create fetch options with auth token
 */
export function createFetchOptions(options: RequestInit = {}): RequestInit {
  const token = getToken()
  const authHeaders: Record<string, string> = token
    ? { Authorization: `Bearer ${token}` }
    : {}

  return {
    ...defaultFetchOptions,
    ...options,
    headers: {
      ...defaultFetchOptions.headers,
      ...authHeaders,
      ...options.headers,
    },
  }
}

/**
 * Create headers with auth token
 */
export function createAuthHeaders(token?: string): HeadersInit {
  const headers: HeadersInit = {
    'Content-Type': 'application/json',
  }

  if (token) {
    headers['Authorization'] = `Bearer ${token}`
  }

  return headers
}
